import axios, { AxiosResponse, } from 'axios';
import { ChatMessage, PagedResponse } from 'domain/domain';
import { getHeaders, BASE_URL } from './common';

export function getMessagesByName(name: string, query: string, page: number) : Promise<AxiosResponse<PagedResponse<ChatMessage>>> {
    return axios.get(BASE_URL + `/api/2/search?sender=${name}&page=${page}&query=${query ? query : ""}`, {headers: getHeaders()});
}